export enum AttributeNameEnum {
  SerialNumber = 'serialNumber',
  SignedByArtist = 'signedByArtist',
  SignatureDescription = 'signatureDescription',
  Height = 'height',
  Width = 'width',
  Depth = 'depth',
  IsFramed = 'isFramed',
  FrameMaterial = 'frameMaterial',
  HeightWithFrame = 'heightWithFrame',
  WidthWithFrame = 'widthWithFrame',
  DepthWithFrame = 'depthWithFrame',
  Medium = 'medium',
  Weight = 'weight',
  AuthenticityCertificate = 'authenticityCertificate',
  Subject = 'subject',
  SubjectOther = 'subjectOther',
  Style = 'style',
  StyleOther = 'styleOther',
  Technique = 'technique',
  TechniqueOther = 'techniqueOther',
  Material = 'material',
  MaterialOther = 'materialOther',
  Color = 'color'
}
